import { render, staticRenderFns } from "./SnatchVoucher.vue?vue&type=template&id=25e1bb6a"
import script from "./SnatchVoucher.vue?vue&type=script&lang=js"
export * from "./SnatchVoucher.vue?vue&type=script&lang=js"
import style0 from "./SnatchVoucher.vue?vue&type=style&index=0&id=25e1bb6a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports